/* @ngInject */
function CustomizationPropertiesController ($scope, $rootScope, $timeout, $translate) {
  $scope.flags = {
    optionIncompatible: false
  }

  $scope.selectedRestriction = null

  const api = {
    _checkOptionIncompatible,
    _reloadData
  }

  this.getApi = () => api

  activate()

  function activate () {
    $scope.tabsLoadingData.customizationTab = false
    const isMP4Selected = $scope.formProperties.downloadOptions.includes('MP4')
    if (!isMP4Selected) {
      $timeout(() => {
        $scope.formProperties.downloadOptions.push('MP4')
      }, 0, true)
    }
  }

  $scope.$on('template-props.reload-data', api._reloadData)

  $scope.$watch('formProperties.selectedFormat', api._reloadData)

  $scope.onChangeApproval = (event) => {
    $scope.formProperties.approval = event.detail.value
  }

  $scope.onClickDownloadOption = (type) => {
    if ($scope.formProperties.downloadOptions.includes(type)) {
      const index = $scope.formProperties.downloadOptions.findIndex(option => option === type)
      $scope.formProperties.downloadOptions.splice(index, 1)
    } else {
      $scope.formProperties.downloadOptions.push(type)
    }

    api._checkOptionIncompatible()
  }

  $scope.shouldShowWebpOption = () => {
    return $rootScope.oUserCompanyFeatures?.includes('WEBP_TEMPLATE_DOWNLOAD')
  }

  function _checkOptionIncompatible () {
    $scope.flags.optionIncompatible = false

    const formatTypes = {
      DIGITAL: () => {
        if ($scope.formProperties.downloadOptions.includes('PRINTABLE_PDF') || $scope.formProperties.downloadOptions.includes('TIFF')) {
          $scope.flags.optionIncompatible = true
        }
      },
      PRINTABLE: () => {
        if ($scope.formProperties.downloadOptions.includes('PNG') || $scope.formProperties.downloadOptions.includes('PDF')) {
          $scope.flags.optionIncompatible = true
        }
      }
    }

    if (formatTypes[String($scope.formProperties.selectedFormat?.type)]) {
      formatTypes[String($scope.formProperties.selectedFormat.type)]()
    }
  }

  function _reloadData () {
    api._checkOptionIncompatible()
  }
}

export { CustomizationPropertiesController }
